import { Grid } from '@material-ui/core';
import * as React from 'react';

import { Container } from '../../../Layout/components/Container';
import { IAgencyTeamMember } from '../../store/models';
import { TeamMember } from './teamMember';

import './index.scss';

interface IProps {
    content: IAgencyTeamMember[];
}

export const TeamMembers: React.FC<IProps> = ({
    content: members
}) => {
    return (
        <Container>
            <div className="team">
                <div className="team__title">
                    <h1>Our team</h1>
                </div>
                <div className="team__members">
                    <Grid container>
                        {members.map(member => (
                            <TeamMember
                                key={member.id}
                                member={member}
                            />
                        ))}
                    </Grid>
                </div>
            </div>
        </Container>
    );
};
